import React, { useEffect, Suspense, lazy, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Cookies from 'js-cookie';
import PageLoading from '../components/common/spinners/PageLoading'
import LeadPage from '../components/common/page/LeadPage'
import NotFound from '../pages/not-found/NotFound '


const Home = lazy(() => import('../pages/lead/home/Home'))
const Prospects = lazy(() => import('../pages/lead/prospects/Prospects'))
const ProspectView = lazy(() => import('../pages/lead/view-prospect/ViewProspect'))
const MyBucket = lazy(() => import('../pages/lead/my-bucket/MyBucket'))
const ViewLead = lazy(() => import('../pages/lead/view-lead/ViewLead'))
const CUProspect = lazy(() => import('../pages/lead/cu-prospect/CUProspect'))
const AttendLead = lazy(() => import('../pages/lead/attend/AttendLead'))
const LeadCalendar = lazy(() => import('../pages/lead/calendar/LeadCalendar'))
const Duplicate = lazy(() => import('../pages/lead/duplicate/Duplicate'))
const SearchProspect = lazy(() => import('../pages/lead/search-prospect/SearchProspect'))
const SingleProspectView = lazy(() => import('../pages/lead/search-prospect/ViewProspect'))



const LeadRouter = () => {
    let isAuthenticated = false
    const [pageHead, setPageHead] = useState({ title: null, desc: null })
    const rfs_tkn = Cookies.get('_rfs_tkn');
    const DVC_ID = Cookies.get('DVC_ID');


    if (DVC_ID && rfs_tkn) {
        isAuthenticated = true
    }

    useEffect(() => {
        // Change Title
        document.title = `Lead | Sales App | Alliance`;

        // eslint-disable-next-line
    }, [])


    return (
        <LeadPage pageHead={pageHead}>

            <Suspense fallback={<PageLoading />}>
                <Routes>
                    {/* Prospects */}
                    <Route path='/prospects-queue' element={<PrivateRoute element={<Prospects setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospects-queue/register' element={<PrivateRoute element={<CUProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospects-queue/:prospect_id' element={<PrivateRoute element={<ProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Duplicate */}
                    <Route path='/bucket-list/duplicate/:primary_number' element={<PrivateRoute element={<Duplicate setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
               
                    {/* Bucket */}
                    <Route path='/bucket-list' element={<PrivateRoute element={<MyBucket setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/reg-update' element={<PrivateRoute element={<CUProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/:lead_id' element={<PrivateRoute element={<ViewLead setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/:lead_id/attend' element={<PrivateRoute element={<AttendLead setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />


                    {/* Calendar */}
                    <Route path='/calendar/:view/:theYear/:theMonth/:theDate' element={<PrivateRoute element={<LeadCalendar setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Home */}
                    <Route path='/prospect/search' element={<PrivateRoute element={<SearchProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospect/:prospect_id/view' element={<PrivateRoute element={<SingleProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    <Route path='/' element={<PrivateRoute element={<Home setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />


                    {/* 404 Route */}
                    <Route path="/*" element={<NotFound setPageHead={setPageHead} />} />
                </Routes>
            </Suspense>
        </LeadPage>
    )
}

export default LeadRouter


function PrivateRoute({ element, isAuthenticated, }) {
    return isAuthenticated ? element : window.location.href = 'https://worker.alliancedev.in/?page=home';
}

